import { Box, Link, Typography } from "@material-ui/core";
import config from "config";
import React from "react";
import i18n from "./i18n";

// prop types
interface DocumentsTabProps {
    clubId?: string,
    isOwner: boolean,
    isCompany: boolean | undefined,
}

// link
const StyledLink = ({ label, url }: { label: string, url: string }) => (
    <Link
        href={url}
        style={{ display: "block", margin: "8px" }}
        target="_blank"
    >
        {label}
    </Link>
);

// owner accounting table for reports
const DocumentsTab = ({ clubId, isCompany, isOwner }: DocumentsTabProps) => (
    <Box style={{ padding: "16px" }}>
        <Typography paragraph>
            {i18n.documentsDesc}
            <StyledLink label="Admin-Anleitung" url={config.documents.adminManual} />
            <StyledLink label="Onboarding Paket" url={config.documents.onboardingBundle} />
            {isOwner && <StyledLink label="Gemeinsame Verantwortung" url={config.documents.contractSharedResponsibility} />}
            {isCompany && <StyledLink label="Datenschutz" url={config.documents.b2bPrivacy} />}
            {isCompany && <StyledLink label="Nutzungsbedingungen" url={config.documents.b2bTermsOfUse} />}
        </Typography>
    </Box>
);

export default DocumentsTab;
